export default __webpack_public_path__ + "static/media/card1@2x.726f8e35.png";